export default __webpack_public_path__ + "static/media/pulumi.d77ea8f0.svg";